<div
  id="pcoded"
  class="pcoded"
  [attr.nav-type]="navType"
  [attr.theme-layout]="themeLayout"
  [attr.vertical-placement]="verticalPlacement"
  [attr.vertical-layout]="verticalLayout"
  [attr.pcoded-device-type]="pcodedDeviceType"
  [attr.vertical-nav-type]="verticalNavType"
  [attr.vertical-effect]="verticalEffect"
  [attr.vnavigation-view]="vnavigationView"
  [attr.sidebar-img]="sidebarImg"
  [attr.sidebar-img-type]="sidebarImgType"
  [attr.layout-type]="layoutType"
  (window:resize)="onResize($event)"
>
  <div class="pcoded-overlay-box"></div>
  <div class="pcoded-container navbar-wrapper">
    <nav
      class="navbar header-navbar pcoded-header"
      [attr.header-theme]="headerTheme"
      [attr.pcoded-header-position]="pcodedHeaderPosition"
    >
      <div class="navbar-wrapper">
        <div class="navbar-logo">
          @if (auth.isMfaSatisfied) {
            <a
              (click)="toggleOpened()"
              (clickOutside)="onClickedOutsideSidebar($event)"
              [exclude]="'#main_navbar'"
              class="mobile-menu"
              id="mobile-collapse"
            >
              <i class="icon-menu"></i>
            </a>
          }

          <a
            [class.disabled]="!auth.isMfaSatisfied"
            [routerLink]="auth.isMfaSatisfied ? ['/' + DASHBOARD_ROUTE] : null"
            class="ogo-logo"
          >
            <img style="width: 35%" class="img-fluid" src="assets/images/logo.png" alt="Theme-Logo" />
          </a>
          <a class="mobile-options" (click)="toggleHeaderNavRight()">
            <i class="icon-more"></i>
          </a>
        </div>

        <div class="navbar-container container-fluid">
          @if (auth.isMfaSatisfied) {
            <ul class="nav-left">
              <li>
                <div class="sidebar_toggle">
                  <a>
                    <i class="icon-menu"></i>
                  </a>
                </div>
              </li>
              <li>
                <div class="search-results"></div>
              </li>
              <li></li>

              <a
                *ngIf="
                  userFeatures.has(ACL_SITE_EDIT) && !hideAddDomain && auth.currentOrganization.clusters?.length
                "
                [routerLink]="[MY_SITES_ROUTE, ADD_ROUTE]"
                class="add-domain"
                style="line-height: 54px; margin-top: 15px; color: #fff"
              >
                <strong [innerHTML]="'AjouterUnSite' | translate"></strong>&nbsp;
                <i class="btn-add-domain icofont icofont-plus-circle" style="font-size: 20px"></i>
              </a>
            </ul>
          }
          <ul [@mobileHeaderNavRight]="navRight" [ngClass]="navRight" class="nav-right">
            <li
              (click)="toggleChangeOrganization()"
              (clickOutside)="notificationOutsideClick('organization')"
              id="organization-picker"
              class="organization user-profile header-notification"
              [ngClass]="changeOrganizationnizationClass"
            >
              {{ auth.currentOrganization?.name }}
              <ul [@notificationBottom]="changeOrganization" class="show-notification profile-notification">
                <ng-template ngFor let-organization [ngForOf]="auth.organizations" let-i="index">
                  <li
                    *ngIf="auth.currentOrganization?.code != organization.code"
                    class="flex-align-items"
                    [id]="'org-option-' + organization.code"
                    (click)="changeCurrentOrganization(organization.code)"
                  >
                    <span>{{ organization.name }}</span>
                  </li>
                </ng-template>
                <li
                  [routerLink]="['/' + ADD_ORGANIZATION_ROUTE]"
                  class="flex-align-items pointer ogo-link"
                  id="new-org"
                >
                  + {{ 'CreateNewOrganization' | translate }}
                </li>
              </ul>
            </li>
            <li
              (click)="toggleProfileNotification()"
              (clickOutside)="notificationOutsideClick('profile')"
              id="user-drop-down"
              class="user-profile header-notification"
              [ngClass]="profileNotificationClass"
            >
              <a class="profile-dropdown">
                <span>{{
                  auth?.user?.lastName && auth?.user?.firstName
                    ? auth.user.lastName + ' ' + auth.user.firstName
                    : auth?.user?.email
                }}</span>
                <i class="icon-angle-down"></i>
              </a>
              <ul [@notificationBottom]="profileNotification" class="show-notification profile-notification">
                <li
                  [routerLink]="['/' + MY_PROFILE_ROUTE]"
                  [queryParams]="{ tab: 'parameters' }"
                  id="menu-my-profile"
                  class="flex-align-items pointer"
                >
                  <i class="icon-user"></i><span [innerHTML]="'MyProfile' | translate"></span>
                </li>
                <li
                  [routerLink]="['/' + MY_ORGANIZATION_ROUTE]"
                  [queryParams]="{ tab: 'parameters' }"
                  id="menu-my-organization"
                  class="flex-align-items pointer"
                >
                  <i class="icon-briefcase" style="font-size: 13px"></i
                  ><span [innerHTML]="'MyOrganization' | translate"></span>
                </li>
                <li (click)="goToDocumentation()" class="flex-align-items pointer" id="menu-documentation">
                  <i class="icon-book"></i><span [innerHTML]="'Documentation' | translate"></span>
                </li>
                <li (click)="logout()" id="logout" class="flex-align-items pointer" style="color: #ff5370">
                  <i class="icon-power-off"></i><span [innerHTML]="'Deconnexion' | translate"></span>
                </li>
              </ul>
            </li>
            <li>
              <ul class="nav navbar-nav navbar-right">
                <li>
                  <a>
                    <span
                      (click)="changeLang('en')"
                      [ngClass]="{ 'selected-lang': auth.getCurrentLanguage() == 'en' }"
                      class="lang-selector"
                      id="lang-en"
                      >EN</span
                    >
                    |
                    <span
                      [ngClass]="{ 'selected-lang': auth.getCurrentLanguage() == 'fr' }"
                      (click)="changeLang('fr')"
                      id="lang-fr"
                      class="lang-selector"
                    >
                      FR</span
                    >
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="pcoded-main-container" [style.margin-top]="headerFixedMargin">
      <div class="pcoded-wrapper">
        @if (auth.isMfaSatisfied) {
          <nav
            (clickOutside)="onClickedOutsideSidebar($event)"
            [attr.active-item-theme]="activeItemTheme"
            [attr.navbar-theme]="navBarTheme"
            [attr.pcoded-header-position]="pcodedHeaderPosition"
            [attr.pcoded-navbar-position]="pcodedSidebarPosition"
            [exclude]="'#mobile-collapse'"
            class="pcoded-navbar custom-scrollbar"
            id="main_navbar"
          >
            <div appAccordion class="pcoded-inner-navbar main-menu">
              <ul
                *ngFor="let menuItem of menuItems"
                [attr.item-border-style]="itemBorderStyle"
                [attr.item-border]="itemBorder"
                [attr.subitem-border]="subItemBorder"
                appAccordionLink
                class="pcoded-item pcoded-left-item"
                group="{{ menuItem.state }}"
              >
                @switch (menuItem.type) {
                  @case ('link') {
                    <li
                      [appAccess]="menuItem.acl"
                      [routerLinkActive]="['active']"
                      appAccordionLink
                      class="menu-item"
                      group="{{ menuItem.state }}"
                    >
                      <a
                        (click)="windowWidth < 992 && toggleOpened()"
                        *ngIf="menuItem.main_state; else mainContent"
                        [routerLink]="['/', menuItem.main_state, menuItem.state]"
                        appAccordionToggle
                        id="{{ 'menu-item-' + menuItem.name }}"
                        target="{{ menuItem.target ? '_blank' : '_self' }}"
                      >
                        <span class="pcoded-micon"><i class="{{ menuItem.icon }}"></i></span>
                        <span class="pcoded-mtext">{{ menuItem.name | translate }}</span>
                        <span class="pcoded-mcaret"></span>
                      </a>
                      <ng-template #mainContent>
                        <a
                          (click)="windowWidth < 992 && toggleOpened()"
                          *ngIf="menuItem.state"
                          [routerLink]="['/', menuItem.state]"
                          appAccordionToggle
                          id="{{ 'menu-item-' + menuItem.name }}"
                          target="{{ menuItem.target ? '_blank' : '_self' }}"
                        >
                          <span class="pcoded-micon"><i class="{{ menuItem.icon }}"></i></span>
                          <span class="pcoded-mtext">
                            {{ menuItem.name | translate }}
                            <label-beta *ngIf="menuItem.badge" [label]="menuItem.badge" />
                          </span>
                          <span class="pcoded-mcaret"></span>
                        </a>
                        <a
                          *ngIf="!menuItem.state"
                          appAccordionToggle
                          href="{{ menuItem.href }}"
                          target="{{ menuItem.target ? '_blank' : '_self' }}"
                        >
                          <span class="pcoded-micon"><i class="{{ menuItem.icon }}"></i></span>
                          <span class="pcoded-mtext">{{ menuItem.name | translate }}</span>
                          <span class="pcoded-mcaret"></span>
                        </a>
                      </ng-template>
                    </li>
                  }
                  @case ('sub') {
                    <li
                      [appAccess]="menuItem.acl"
                      [attr.dropdown-icon]="dropDownIcon"
                      [attr.subitem-icon]="subItemIcon"
                      [routerLinkActive]="['active']"
                      appAccordionLink
                      class="pcoded-hasmenu"
                      group="{{ menuItem.state }}"
                    >
                      <a
                        [routerLinkActive]="['active']"
                        appAccordionToggle
                        class="menu-item"
                        id="{{ 'menu-item-' + menuItem.name }}"
                      >
                        <span class="pcoded-micon"><i class="{{ menuItem.icon }}"></i></span>
                        <span class="pcoded-mtext"
                          >{{ menuItem.name | translate }} <label-beta *ngIf="menuItem.badge" [label]="menuItem.badge"
                        /></span>
                        <span class="pcoded-mcaret"></span>
                      </a>
                      <ul class="pcoded-submenu">
                        <ng-template [ngForOf]="menuItem.children" let-submenuItem ngFor>
                          <li
                            *ngIf="submenuItem.type !== 'sub'"
                            [appAccess]="submenuItem.acl"
                            [routerLinkActive]="['active']"
                          >
                            <a
                              (click)="windowWidth < 992 && toggleOpened()"
                              *ngIf="menuItem.state"
                              [routerLink]="['/', menuItem.state, submenuItem.state]"
                              id="{{ 'menu-item-' + menuItem.name + '-' + submenuItem.name }}"
                              target="{{ submenuItem.target ? '_blank' : '_self' }}"
                            >
                              <span class="pcoded-micon">
                                <i class="icon-angle-right"></i>
                              </span>
                              <span class="pcoded-mtext"
                                >{{ submenuItem.name | translate }}
                                <label-beta *ngIf="submenuItem.badge" [label]="submenuItem.badge"
                              /></span>
                              <span class="pcoded-mcaret"></span>
                            </a>
                          </li>
                        </ng-template>
                      </ul>
                    </li>
                  }
                }
              </ul>
            </div>
          </nav>
        }
        <div [class]="auth.isMfaSatisfied ? 'pcoded-content' : 'mfa-not-verified'">
          <div class="pcoded-inner-content">
            <div class="main-body">
              <div class="page-wrapper">
                <router-outlet></router-outlet>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
